<template>
  <div class="home">
      
    <b-container>
        <!--<div class="topnav" id="myTopnav">
            <b-navbar >
                <b-navbar-brand href="#">
                <img src="img/logo.png" alt="">
                </b-navbar-brand>
                <b-nav-text>{{employee}}</b-nav-text>
                <b-nav-item active to="/">Home</b-nav-item>
                <b-nav-item to="/viewUnresolvedJobs">View Jobs</b-nav-item>
                <b-nav-item to="/viewResolvetickets">View Tickets</b-nav-item>
                <b-nav-item to="/createTicket">Create Tickets</b-nav-item>
                <b-nav-item to="/createTravel"  >Pre Travel Booking</b-nav-item>
            </b-navbar >
        </div>-->
        <b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link> 
            <br>
            <br>
            </b-col>
         </b-row>
         <b-row>
         <b-col class="text-center">
            <img src="img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col>
        </b-row> <br>  
		<b-row class="row">
			<b-col id="welcome" class="text-center"><small>Welcome {{employee}}</small></b-col>
			
		</b-row>
       
        <hr>
		<b-row class="row">
            <b-col>
                <!--<form action="/viewUnresolvedJobs" id="viewJob" method="get">
                    <input type="submit" value="View My Unresolved Jobs" class="btn btn-primary" style="width:100%;">
                </form>-->
                <!--<b-button href="/ticketcop_vue/viewUnresolvedJobs" class="btn-block">View My Unresolved Jobs</b-button>-->
                <router-link :to="{ name: 'viewJobs', params: { employee: employee } }" tag="div" >
                 <button class="btn btn-primary w-100">View My Unresolved Jobs</button> 
                    <!--View My Unresolved Jobs-->
                </router-link>
            </b-col>
		</b-row>
        <br>
		<b-row class="row">
        
		</b-row>
		<div class="row">
            <b-col>
                  <router-link :to="{ name: 'createTicket', params: { employee: employee } }" tag="div">
                     <button class="btn btn-primary w-100">Create tickets / Job</button>   
                      </router-link>
            </b-col>
		</div>
		<div class="row">
		<br>
		</div>
		<div class="row">
            <b-col>    
                <!--<b-button href="/viewResolveTickets" class="w-100 btn-primary" variant="primary">View / Resolve Tickets</b-button>-->
                <router-link :to="{ name: 'viewResolveTickets', params: { employee: employee } }" tag="div">
                     <button class="btn btn-primary w-100">View / Resolve Tickets</button>   
                      </router-link>
            </b-col>
		</div>
		<div class="row">
		<br>
		</div>
		<div class="row">
            <b-col>    
                <!--<b-button href="/viewResolveTickets" class="w-100 btn-primary" variant="primary">View / Resolve Tickets</b-button>-->
                <router-link :to="{ name: 'timeSheet', params: { employee: employee } }" tag="div">
                     <button class="btn btn-primary w-100">Timesheet</button>   
                      </router-link>
            </b-col>
		</div>
		<div class="row">
		<br>
		</div>
		<div class="row">
            <b-col>   
                <!--<b-button href="/createTravel" class="btn-block">Pre Travel Booking</b-button>   -->
                 <router-link :to="{ name: 'createTravel', params: { employee: employee } }" tag="div">
                     <button class="btn btn-primary w-100">Pre Travel Booking</button>   
                      </router-link>
            </b-col>
		</div>
        <div v-if="userObject.doCSI">
            <div class="row">
            <br>
            </div>
            <div class="row">
                <b-col>   
                    <!--<b-button href="/createTravel" class="btn-block">Pre Travel Booking</b-button>   -->
                    <router-link :to="{ name: 'createCSI', params: { employee: employee } }" tag="div">
                        <button class="btn btn-primary w-100">Create CSI</button>   
                        </router-link>
                </b-col>
            </div>
        </div>
		<div class="row">
		<hr>
		<br>
		</div>
		<!--    to do implment thi sbased on user
		<div class="row">
		
		<form action="createCSI" id="createCSI" method="get">
			<div class="col-md-12">
				<input type="submit" value="Create CSI" class="btn btn-primary" style="width:100%;">
			</div>
		</form>
		</div>
		<div class="row">
		<br>
		</div>
		
		-->
		
		<div class="row">
		<br>
		</div>
		<div class="row">
		<br>
		</div>
		<div class="row">
            <b-col>  
                 <b-button  class="btn-block" @click="logout" >Log Out</b-button> 
            </b-col>  
		</div>
		<div class="row">
		<br>
		</div>
		<div class="row">
            <b-col>  

                <b-button  href="https://energydrive.dnsalias.com" class="btn-block">Back to EDS Landing</b-button>
            </b-col>  
		</div>
		<div class="row">
		<br>
		</div>
        <div class="row">
		<br>
		</div>
		
		
	</b-container>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import jwt_decode from 'jwt-decode';
import axios from 'axios';
export default {
   name: 'home',
   data: () => ({ 
       'employee' : "",
        'userObject' : null
   }),

   methods : {
       logout : function () {
           localStorage.removeItem('jwt');
           console.log("Removed jwt");
            this.$router.push({
                                path: '/login'
                              
                            })
       }
   },
   created: function () {
       console.log("What mode am I in");
       console.log(process.env.NODE_ENV);
       console.log("App Version "+this.$app_version);
       let userID = "1."+localStorage.getItem('idemployee');
        console.log("Setting google user ID");
        this.$ga.set("userId", userID);
       //console.log("Created");
       //console.log(this.$route.params);
       if ( process.env.NODE_ENV == "development" )
       {
           localStorage.setItem('ticketCopURL',"https://energydrive.dnsalias.com/ticketcop_dev");
       }
       else
       {
           localStorage.setItem('ticketCopFrontend',"https://energydrive.dnsalias.com/ticketcop");
           localStorage.setItem('ticketCopURL',"https://energydrive.dnsalias.com/ticketcopapi");
       }
       
       //localStorage.setItem('ticketCopURL',"https://energydrive.dnsalias.com/ticketcopapi");

       
       this.employee = this.$route.params.employee;
        let employee = localStorage.getItem('employee');
        let decoded = jwt_decode(localStorage.getItem('jwt'));
        this.userObject = decoded;
      // let idemployee = localStorage.getItem('idemployee');
       this.employee = employee;
      // this.idemployee = employee;
      axios.get(localStorage.getItem('ticketCopURL') +'/checkAppVersion', {
            params: {
                    app_version : this.$app_version
                   
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
                console.log(response.data);
                //console.log("getting tickets.."+response.data.length);
                
                if (response.data == "OUTDATED")
                {
                    //alert("This version is obsolete. browser will now reload to get the latest version.");
                    console.log("App version is incorrect.");
                    location.reload();
                }
                else
                {
                    console.log("App version is correct.");
                }
                

                
                //mainObject.ticketTagSubCategory_visible = true;

                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    
                    
            })
            // END OF AXIOS Call*/

   }
  //components: {
  //  HelloWorld
 // }
}
</script>
